"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var profile_container_1 = __importDefault(require("../views/profile-container"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var sheet_1 = __importDefault(require("../views/sheet"));
var game_area_1 = require("../utilities/game-area");
var stack_container_1 = __importStar(require("../views/stack-container"));
var category_button_1 = __importDefault(require("../views/category-button"));
var message_button_1 = __importStar(require("../views/message-button"));
var page_button_1 = __importStar(require("../views/page-button"));
var name_container_1 = __importDefault(require("../views/name-container"));
var calculator_1 = __importStar(require("../models/calculator"));
var calculator_2 = require("../models/calculator");
var reaction_1 = require("../models/reaction");
var color_1 = require("../utilities/color");
var gsap_1 = require("gsap");
var PixiPlugin_1 = require("gsap/PixiPlugin");
var i18next_1 = __importDefault(require("i18next"));
gsap_1.gsap.registerPlugin(PixiPlugin_1.PixiPlugin);
PixiPlugin_1.PixiPlugin.registerPIXI(PIXI);
var SEND_MESSAGE_ROWS = 3;
var SEND_MESSAGE_COLUMNS = 1;
var SEND_MESSAGE_COUNT = SEND_MESSAGE_ROWS * SEND_MESSAGE_COLUMNS;
var SEND_EMOJI_ROWS = 2;
var SEND_EMOJI_COLUMNS = 4;
var SEND_EMOJI_COUNT = SEND_EMOJI_ROWS * SEND_EMOJI_COLUMNS;
var SendState = /** @class */ (function (_super) {
    __extends(SendState, _super);
    function SendState(app, client) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        return _this;
    }
    Object.defineProperty(SendState.prototype, "profileContainer", {
        get: function () {
            if (!this._profileContainer) {
                this._profileContainer = new profile_container_1.default(this._app.loader.resources);
                this._profileContainer.scale.set(0.5);
                this._profileContainer.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_HEIGHT * 0.5);
            }
            return this._profileContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "backButton", {
        get: function () {
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, this.hideSheet.bind(this));
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("send_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "nameContainer", {
        get: function () {
            if (!this._nameContainer) {
                this._nameContainer = new name_container_1.default(this._app.loader.resources.ui.textures);
                this._nameContainer.maxGems = calculator_1.default.evolutions(calculator_1.MAX_STAGE);
            }
            return this._nameContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "sheet", {
        get: function () {
            if (!this._sheet) {
                this._sheet = new sheet_1.default(this._app.loader.resources.ui.textures);
                this._sheet.contentContainer.addChild(this.stackContainer);
                this._sheet.contentContainer.addChild(this.previousPageButton);
                this._sheet.contentContainer.addChild(this.nextPageButton);
            }
            return this._sheet;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "categoryButtons", {
        get: function () {
            var e_1, _a;
            if (!this._categoryButtons) {
                this._categoryButtons = [];
                try {
                    for (var _b = __values(Object.keys(reaction_1.REACTION_CATEGORIES)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var categoryID = _c.value;
                        var button = new category_button_1.default(this._app.loader.resources.ui.textures, categoryID, this.onCategory.bind(this));
                        this.categoryButtons.push(button);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            return this._categoryButtons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "categoryContainer", {
        get: function () {
            if (!this._categoryContainer) {
                this._categoryContainer = new stack_container_1.default(this.categoryButtons, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 12
                });
            }
            return this._categoryContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "messageButtons", {
        get: function () {
            if (!this._messageButtons) {
                this._messageButtons = [];
                for (var i = 0; i < SEND_MESSAGE_COUNT; i++) {
                    var button = new message_button_1.default(this._app.loader.resources.ui.textures, this.onElement.bind(this));
                    this._messageButtons.push(button);
                }
            }
            return this._messageButtons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "emojiButtons", {
        get: function () {
            if (!this._emojiButtons) {
                this._emojiButtons = [];
                for (var i = 0; i < SEND_EMOJI_COUNT; i++) {
                    var button = new message_button_1.default(this._app.loader.resources.ui.textures, this.onElement.bind(this));
                    this._emojiButtons.push(button);
                }
            }
            return this._emojiButtons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "elementColumns", {
        get: function () {
            if (this._selectedCategoryID == "message") {
                return SEND_MESSAGE_COLUMNS;
            }
            return SEND_EMOJI_COLUMNS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "elementButtons", {
        get: function () {
            if (this._selectedCategoryID == "message") {
                return this.messageButtons;
            }
            return this.emojiButtons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "elementRowHeight", {
        get: function () {
            if (this._selectedCategoryID == "message") {
                return 60;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "elementRowSpacing", {
        get: function () {
            if (this._selectedCategoryID == "message") {
                return 0;
            }
            return -8;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "elementColumnSpacing", {
        get: function () {
            if (this._selectedCategoryID == "message") {
                return 0;
            }
            return -8;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "elementCount", {
        get: function () {
            if (this._selectedCategoryID == "message") {
                return SEND_MESSAGE_COUNT;
            }
            return SEND_EMOJI_COUNT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "elementIDs", {
        get: function () {
            return reaction_1.REACTION_CATEGORIES[this._selectedCategoryID];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "elementContainer", {
        get: function () {
            if (!this._elementContainer) {
                this._elementContainer = stack_container_1.default.Group(this.elementButtons, this.elementColumns, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: this.elementColumnSpacing,
                    minHeight: this.elementRowHeight
                }, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: this.elementRowSpacing,
                    minWidth: game_area_1.GAME_SAFE_AREA.width
                });
            }
            return this._elementContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.categoryContainer,
                    this.elementContainer
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 18,
                    minWidth: game_area_1.GAME_WIDTH
                });
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "statusLabel", {
        get: function () {
            if (!this._statusLabel) {
                this._statusLabel = new PIXI.Text("");
                this._statusLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    fontSize: 19,
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._statusLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "previousPageButton", {
        get: function () {
            if (!this._previousPageButton) {
                this._previousPageButton = new page_button_1.default(this._app.loader.resources.ui.textures, page_button_1.PAGE_BUTTON_TYPE.PREVIOUS, this.onPreviousPage.bind(this));
            }
            return this._previousPageButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "nextPageButton", {
        get: function () {
            if (!this._nextPageButton) {
                this._nextPageButton = new page_button_1.default(this._app.loader.resources.ui.textures, page_button_1.PAGE_BUTTON_TYPE.NEXT, this.onNextPage.bind(this));
            }
            return this._nextPageButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        set: function (value) {
            if (!this.isValidPage(value)) {
                return;
            }
            this._currentPage = value;
            this.previousPageButton.visible = this.isValidPage(value - 1);
            this.nextPageButton.visible = this.isValidPage(value + 1);
            this.updateElements();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "dragonContainer", {
        get: function () {
            return this._dragonContainer;
        },
        set: function (value) {
            this._dragonContainer = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SendState.prototype, "dragon", {
        get: function () {
            return this._dragon;
        },
        set: function (value) {
            this._dragon = value;
        },
        enumerable: false,
        configurable: true
    });
    SendState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this.profileContainer);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.addChild(this.nameContainer);
        this._app.stage.addChild(this.sheet);
        this.dragonContainer.setIdleAnimation();
        this.profileContainer.dragonSlot.addChild(this.dragonContainer);
        var dragonPosition = this._app.stage.toLocal(this.dragonContainer.position, this.dragonContainer);
        this.nameContainer.setTitle(this.dragon.status.name, true, calculator_1.default.evolutions(this.dragon.status.stage));
        this.nameContainer.position.set(dragonPosition.x - (this.nameContainer.width * 0.5), dragonPosition.y + 16);
        this.showSheet();
        this._client.sendEvent("send_entered", {
            dragon: this.dragon
        });
    };
    SendState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this.profileContainer);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.removeChild(this.nameContainer);
        this._app.stage.removeChild(this.sheet);
        this.profileContainer.dragonSlot.removeChild(this.dragonContainer);
    };
    SendState.prototype.showSheet = function () {
        this.setSelectedCategory(Object.keys(reaction_1.REACTION_CATEGORIES)[0], false);
        this.sheet.show(false, false);
        this.sheet.show(true, true);
    };
    SendState.prototype.hideSheet = function () {
        var _this = this;
        this.sheet.show(false, true, function () {
            _this.stateMachine.pop();
        });
    };
    SendState.prototype.updateCategories = function (animated) {
        for (var i = 0; i < this.categoryButtons.length; i++) {
            var button = this.categoryButtons[i];
            var categoryID = Object.keys(reaction_1.REACTION_CATEGORIES)[i];
            button.selected = categoryID == this._selectedCategoryID;
            if (categoryID == this._selectedCategoryID) {
                var x = (game_area_1.GAME_WIDTH * 0.5) - button.x - (button.width * 0.5);
                if (animated) {
                    gsap_1.gsap.to(this.categoryContainer, {
                        duration: 0.3,
                        x: x,
                        ease: "Power1.easeInOut"
                    });
                }
                else {
                    this.categoryContainer.x = x;
                }
            }
        }
    };
    SendState.prototype.updateElements = function () {
        for (var i = 0; i < this.elementButtons.length; i++) {
            var button = this.elementButtons[i];
            var elementIndex = this.elementIndex(i);
            button.alpha = elementIndex < this.elementIDs.length ? 1 : 0;
            if (button.alpha == 0) {
                continue;
            }
            var elementID = this.elementIDs[elementIndex];
            var text = i18next_1.default.t(this._selectedCategoryID + "_" + elementID);
            var style = this._selectedCategoryID == "message" ? message_button_1.MESSAGE_BUTTON_STYLE.ACCENT : message_button_1.MESSAGE_BUTTON_STYLE.EMOJI_LARGE;
            button.setText(text, style);
        }
        this.elementContainer.layoutChildren();
        this._previousPageButton.position.set(game_area_1.GAME_SAFE_AREA.left, this.elementContainer.y + ((this.elementContainer.height - this.previousPageButton.height) * 0.5));
        this._nextPageButton.position.set(game_area_1.GAME_SAFE_AREA.right - this.nextPageButton.width, this.elementContainer.y + ((this.elementContainer.height - this.nextPageButton.height) * 0.5));
        this.sheet.show(true, false);
    };
    SendState.prototype.isValidPage = function (page) {
        return page >= 0 && page <= this._numberOfPages - 1;
    };
    SendState.prototype.setSelectedCategory = function (categoryID, animated) {
        this._selectedCategoryID = categoryID;
        var x = this.categoryContainer.x;
        this._elementContainer = null;
        this._stackContainer.arrangedChildren = [
            this.categoryContainer,
            this.elementContainer
        ];
        this.categoryContainer.x = x;
        this.updateCategories(animated);
        var numberOfPages = 1;
        if (this.elementIDs.length != 0) {
            numberOfPages = Math.ceil(this.elementIDs.length / this.elementCount);
        }
        this._numberOfPages = numberOfPages;
        this.currentPage = 0;
    };
    SendState.prototype.onCategory = function (button) {
        var index = this.categoryButtons.indexOf(button);
        var categoryID = Object.keys(reaction_1.REACTION_CATEGORIES)[index];
        this.setSelectedCategory(categoryID, true);
    };
    SendState.prototype.onElement = function (button) {
        var _this = this;
        var points = calculator_2.PARK_REACTION_SEND_XP;
        var index = this.elementButtons.indexOf(button);
        var elementIndex = this.elementIndex(index);
        var elementID = this.elementIDs[elementIndex];
        this._client.sendReaction(this._selectedCategoryID, elementID, this.dragon);
        this._client.award(points);
        this._client.synchronize();
        this._client.sendEvent("send_reaction", {
            type: this._selectedCategoryID,
            value: elementID,
            dragon: this.dragon
        });
        this.statusLabel.text = i18next_1.default.t("send_success").replace("[points]", points.toFixed()) + "\n";
        this.stackContainer.arrangedChildren = [this.statusLabel];
        this.previousPageButton.visible = false;
        this.nextPageButton.visible = false;
        this.sheet.show(true, true, function () {
            gsap_1.gsap.to(_this, {
                duration: 1,
                onComplete: function () {
                    _this.hideSheet();
                }
            });
        });
    };
    SendState.prototype.onPreviousPage = function () {
        this.currentPage -= 1;
    };
    SendState.prototype.onNextPage = function () {
        this.currentPage += 1;
    };
    SendState.prototype.elementIndex = function (offset) {
        return this.currentPage * this.elementCount + offset;
    };
    return SendState;
}(state_1.default));
exports.default = SendState;
